<div class="container">
  <div class="body" *ngFor="let content of contents;let i=index;" [style.top.px]="getTopPosition(content, i)" (click)="click(content)">
    <div class="title">{{content.title}}</div>
    <div>{{content.body}}</div>
  </div>
  <div class="body" *ngFor="let content of removed" [style.top.px]="content.top" [style.opacity]="content.opacity">
    <div class="title">{{content.title}}</div>
    <div>{{content.body}}</div>
  </div>
</div>